export const dotSeparator = '\xa0\xa0\xa0·\xa0\xa0\xa0';
export const pipeSeparator = '\xa0\xa0\xa0|\xa0\xa0\xa0';
